import type { AiBlockedReason } from "../../../api/aiCreditsApi";

/** Shared formatting for the AI credits screens (ADR-0035). */
export const fmtCredits = (n: number | null | undefined) => (n === null || n === undefined ? "ללא הגבלה" : n.toLocaleString("he-IL"));
export const fmtUsd = (n: number) => `$${n.toLocaleString("he-IL", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtDate = (iso: string) => new Date(iso).toLocaleDateString("he-IL");

export const BLOCKED_TEXT: Record<NonNullable<AiBlockedReason>, string> = {
  AI_DISABLED: "ה-AI כבוי בארגון",
  AI_NOT_ALLOWED: "אינך ברשימת המורשים ל-AI בארגון",
  AI_NO_CREDITS: "נגמרו הקרדיטים של הארגון החודש",
  AI_USER_LIMIT: "הגעת למגבלה האישית החודשית",
};

export const TX_LABELS: Record<string, string> = {
  grant: "הענקה",
  purchase: "רכישה",
  adjust: "תיקון",
  allowance: "שינוי הקצאה חודשית",
};

export const PURCHASE_STATUS: Record<string, { label: string; tone: "warning" | "success" | "neutral" | "danger" }> = {
  pending: { label: "ממתינה לאישור", tone: "warning" },
  approved: { label: "אושרה", tone: "success" },
  rejected: { label: "נדחתה", tone: "danger" },
  cancelled: { label: "בוטלה", tone: "neutral" },
};

export function errorMessage(e: unknown, fallback: string): string {
  return (e as { message?: string })?.message || fallback;
}

/** "" → null, digits → number, anything else → undefined (invalid) */
export function parseCredits(text: string): number | null | undefined {
  const t = text.trim();
  if (!t) return null;
  if (!/^\d+$/.test(t)) return undefined;
  const n = Number(t);
  return n > 100_000_000 ? undefined : n;
}
